import { render } from "./Index.vue?vue&type=template&id=4faeb1b0&scoped=true"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"

import "./Index.vue?vue&type=style&index=0&id=4faeb1b0&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-4faeb1b0"

export default script